import React from 'react'
import { Table } from "../UI/Table/Table"

const tableHead = [
  {
    name: "Tag",
    width: "30%"
  },
  {
    name: "Routenverlauf",
    width: "40%"
  },
  {
    name: "Ankunft",
    width: "15%"
  },
  {
    name: "Abfahrt",
    width: "15%"
  }
]

export const DestinationDates = () => {
  return (
    <div className="padding-wide">
      <div className="padding-wide">
        <Table
          hasError={null}
          headline="Reiseplan"
          tableHead={tableHead}
        >
          <tr>
            <td>Samstag, 17. Oktober 2026</td>
            <td>Barcelona, Spanien</td>
            <td></td>
            <td>17:00 Uhr</td>
          </tr>

          <tr>
            <td>Sonntag, 18. Oktober 2026</td>
            <td>Cannes (Côte d'Azur), Frankreich</td>
            <td>09:00 Uhr</td>
            <td>19:00 Uhr</td>
          </tr>

          <tr>
            <td>Montag, 19. Oktober 2026</td>
            <td>Genua (Portofino), Italien</td>
            <td>08:00 Uhr</td>
            <td>18:00 Uhr</td>
          </tr>

          <tr>
            <td>Dienstag, 20. Oktober 2026</td>
            <td>La Spezia (Cinque Terre), Italien</td>
            <td>07:00 Uhr</td>
            <td>18:00 Uhr</td>
          </tr>

          <tr>
            <td>Mittwoch, 21. Oktober 2026</td>
            <td>Civitavecchia (Rom), Italien</td>
            <td>07:00 Uhr</td>
            <td>19:00 Uhr</td>
          </tr>

          <tr>
            <td>Donnerstag, 22. Oktober 2026</td>
            <td>Auf See</td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td>Freitag, 23. Oktober 2026</td>
            <td>Palma de Mallorca (Balearen), Spanien</td>
            <td>09:00 Uhr</td>
            <td>21:00 Uhr</td>
          </tr>

          <tr>
            <td>Samstag, 24. Oktober 2026</td>
            <td>Barcelona, Spanien</td>
            <td>08:00 Uhr</td>
            <td></td>
          </tr>
        </Table>
      </div>
    </div>
  )
}